<template>
	<div>
		{{ vehicle.year }}
		{{ vehicle.make }}
		{{ vehicle.model }}
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name: 'VehicleHeader',
	computed: {
		...mapGetters('vehicle', { vehicle: 'vehicle' })
	}
};
</script>

<style lang="scss" scoped></style>
